const $ = window.jQuery;
const viewport = require('responsive-toolkit');

var breakpointDivs = {
    'xs': $('<div data-breakpoint="xs" class="d-block d-sm-none"></div>'),
    'sm': $('<div data-breakpoint="sm" class="d-none d-sm-block d-md-none"></div>'),
    'md': $('<div data-breakpoint="md" class="d-none d-md-block d-lg-none"></div>'),
    'lg': $('<div data-breakpoint="lg" class="d-none d-lg-block d-xl-none"></div>'),
    'xl': $('<div data-breakpoint="xl" class="d-none d-xl-block d-xxl-none"></div>'),
    'xxl': $('<div data-breakpoint="xxl" class="d-none d-xxl-block"></div>'),
};

viewport.use('Bootstrap5', breakpointDivs);

module.exports = viewport;